import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import {IBlogPost, IPostAssetReference} from "utils/types"
import Badge from "components/Badge"
import { convertBodyToHTMLString } from "utils/helpers"

const maxDescriptionLength = 140;

type Body = {
    raw: string
    references: IPostAssetReference[]
}

function extractDescription(description: string | undefined | object, body: Body | undefined): string {
    let plain = "";
    if (typeof (description) === "string" && description.length > 0) {
        plain = description;
    } else if (body) {
        plain = convertBodyToHTMLString(body).substring(0, maxDescriptionLength);
    }
    plain = plain.replace(/<[^>]*>?/gm, '').replace(/&[^;]+;/g, ' ');
    return plain.substring(0, maxDescriptionLength);
}

type PostProps = {
    post: Partial<IBlogPost>,
    showDescription?: boolean,
    showAuthor?: boolean
}

export default function Post(props: PostProps) {
    let {
        id, slug, title, image, authorName, date, createdAt, description, tags, body
    } = props.post;

    let showDescription = props.showDescription != false;
    let hasAuthor = authorName && authorName.length > 0;
    let showAuthor = props.showAuthor != false && hasAuthor;

    return (
        <div key={id} className="post">
            <div className={"post-image"}>
            <Link to={`/${slug}`}>
                {image && (
                    <GatsbyImage
                        className="image"
                        alt={`Image for ${title}`}
                        image={image.gatsbyImageData}
                    />
                )}
            </Link>
            </div>

            <div className="meta">
                {showAuthor && (
                    <div className="author">
                        <small className={"label"}>{authorName}</small>
                        <small className={"label"}>&middot;</small>
                        <small className={"label"}>{date || createdAt}</small>
                    </div>
                )}

                <h2 className=""><Link to={`/${slug}`}>{title}</Link></h2>

                {showDescription && (
                    <p className="description">
                        {extractDescription(description, body)}
                        &nbsp;&nbsp;<Link to={`/${slug}`}>...read more</Link>
                    </p>
                )}

                <div className="badges">
                    {tags?.map(tag => (
                        <Link key={tag} to={`/tags/${tag}`}>
                            <Badge key={tag}>{tag}</Badge>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    )
}